import dayjs from 'dayjs';
import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';

const firebaseRef = firebase.database();
const { projectCode } = PROJECT_CODE;

export default async function getEditHistory(lotId, callback) {
	await firebaseRef.ref('/kavtek_timestamps/' + projectCode + '/siteplan/lotInformation').once('value', (snapshot) => {
		var historyArr = [];
		var snapObj;

		snapshot.forEach((snap) => {
			var snapLotId = snap.val().lotId;
			if (snapLotId == lotId) {
				snapObj = {
					timestamp: snap.val().timestamp,
					value: snap.val().value,
					oldValue: snap.val().oldValue,
					newValue: snap.val().newValue,
				};
				historyArr.push(snapObj);
			}
		});
		callback(historyArr);
	});
}
